import Core from '../core';
import { AxiosError, AxiosResponse } from 'axios';

async function getEmpDocHistory(DocID: number, EmpID: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v2/empdocdetailshistory?docId=${DocID}&empId=${EmpID}`,
  );

  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}
async function getAttachedDoc_histroy(id: number) {
  const api = Core.getInstance().api();
  const data = await api.get(`/v2/empDocDownloadhistory/${id}`);

  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}
async function updateEmpDocs(payload: any) {
  const api = Core.getInstance().apiforImageUp();
  const data = await api.post(`/v1/empDocumentsUpdate`, payload);

  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}
async function addEmpDocs(payload: any) {
  const api = Core.getInstance().apiforImageUp();
  const data = await api.post(`/v1/empDocuments`, payload);

  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}
async function getActiveDocs(
  company_id: number,
  employee_id: number,
  full_path?: string,
) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/empDocuments?companyId=${company_id}&empId=${employee_id}&full_path=true&locale=${localStorage.getItem(
      'emplang',
    )}`,
  );

  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}
async function getExpiredDocs(company_id: number, employee_id: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/getExpiredDocs?companyId=${company_id}&empId=${employee_id}&locale=${localStorage.getItem(
      'emplang',
    )}`,
  );

  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}
function deleteEmpDocs(id: number) {
  const api = Core.getInstance().api();
  return new Promise((resolve, reject) => {
    api
      .delete(`/v1/empDocuments?id=${id}`)
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}
async function getEmpDocTypes(company_id: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/documentTypes?companyId=${company_id}&docType=employee&locale=${localStorage.getItem(
      'emplang',
    )}`,
  );

  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}
async function getAttachedDoc(id: number, full_path: string) {
  const api = Core.getInstance().apiforImageUp();
  const data = await api.get(`/v1/empDocDownload/${id}?full_path=true`);

  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}

async function updateExpiryEmpDocument(payload: object) {
  const api = Core.getInstance().api();
  try {
    const data = await api.put(`/v2/update-expiry-emp-document`, payload);

    if (data instanceof AxiosError) {
      return data.response;
    }
    const response = data.data;
    return response;
  } catch (error: any) {
    console.error(error);
  }
}
export const documentService = {
  updateExpiryEmpDocument,
  getActiveDocs,
  getExpiredDocs,
  getEmpDocTypes,
  addEmpDocs,
  updateEmpDocs,
  deleteEmpDocs,
  getAttachedDoc,
  getEmpDocHistory,
  getAttachedDoc_histroy,
};
